import { Box } from '@mui/material'

import { Typography } from '@carto/meridian-ds/components'

import { User, UserRoleLabels } from 'features/users'
import { getRole } from 'features/users/model/user'

export default function UserDetails({ user }: { user?: User }) {
  const name = user?.name || user?.email || '—'
  const role = (user && UserRoleLabels[getRole(user)]) || '—'

  return (
    <Box p={2}>
      <Typography mb={0.5} variant="body2" color="textPrimary" noWrap>
        {name}
      </Typography>
      <Typography variant="caption" color="textSecondary">
        {role}
      </Typography>
    </Box>
  )
}
